/*global chrome*/
import React, { Component } from "react";
import poygonplay from "../../../../../images/Polygon 1@2x.png";
import info from "../../../../../images/info.png";
import installed from "../../../../../images/notif-tones/MicrosoftTeams-image (3).png";
import getColors from "../../../../../components/colors";
import deleteIcon from "../../../../../images/training/delete-red.png";
import rtbmenu from "../../../../../images/training/rtb-menu.png";
import {
  viewHelperSkill,
  executeFlow,
  changeSkillAreaView,
  setSelectedItem,
} from "../../../../../redux/actions/skill";

import { notify } from "../../../../../redux/actions/snack";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Store } from "react-notifications-component";
import {
  sendMessageToExtension,
  desktopAgentExists,
} from "../../../../../utility/extension";

const TEMPLATE_WITH_LOOP_RESTRICTION = [
  "UserDocumentation",
  // "WebAutomation",
  "In-App Walkthrough",
  "UserOnboarding",
  "Desktop Walkthrough",
];
class MyHelperItem extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoadingPlay: false };
  }

  componentDidMount() {
    window.$('[data-toggle="popover"]').popover({
      container: "body",
    });
  }

  play = async (item, shouldRestoreData) => {
    this.setState({
      isLoadingPlay: true,
    });
    var data = {
      deviceId: this.props.skillReducer.draftSession,
      skillId: item.id,
      bulk: !TEMPLATE_WITH_LOOP_RESTRICTION.includes(
        item?.SKILL_METADATA?.Template
      ),
      restoreChrome: shouldRestoreData,
    };

    if (data?.deviceId === undefined) {
      this.props.notify(
        "error",
        "You are not connected to Super Assistant. Please install Super Assistant app."
      );
      this.setState({
        isLoadingPlay: false,
      });
    } else {
      const playSkill = await this.props.executeFlow(data);
      this.setState({
        isLoadingPlay: false,
      });
      if (playSkill?.data?.status == false) {
        chrome.runtime.sendMessage(
          process.env.REACT_APP_CHROME_TAB_ID,
          { type: "openLogin" },
          (response) => {
            if (response) {
              // console.log("Extension Response", response);
            }
          }
        );
      }
    }
  };

  notificationPopUp = () => {
    Store.addNotification({
      title: "Note: ",
      message:
        "Ohh! Seems you don't have Super browser extension added to your browser. Please add it before creating/using skills.",
      type: "warning",
      insert: "top",
      container: "top-right",
      dismiss: {
        duration: 5000,
        onScreen: true,
      },
    });
    window.setTimeout(function () {
      window.open(
        `https://chrome.google.com/webstore/detail/techforce-ide-extension/${process.env.REACT_APP_CHROME_TAB_ID}`,
        "_blank"
      );
    }, 5000);
  };

  getExecutionRequirements = async (item) => {
    try {
      let _checkDesktopAgent = false;
      let _checkForExtension = await sendMessageToExtension({ type: "ping" });
      if (
        this.props.skillReducer?.selectedItem?.SKILL_METADATA?.Template !==
        "In-App Walkthrough"
      ) {
        _checkDesktopAgent = await desktopAgentExists();
      }
      let userDeviceId = this.props?.skillReducer?.draftSession;
      if (_checkDesktopAgent.desktopAgentExists) {
        window.jQuery("#alertModal").modal({ show: true });
      } else {
        this.play(item, true);
      }
    } catch (err) {
      this.notificationPopUp();
    }
  };

  viewItem = (viewItem) => {
    this.props.viewHelperSkill(viewItem);
  };

  removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  render() {
    const userRole = this.props?.organizationReducer?.currentOrgUser?.role_id;
    var item = this.props.skill;
    let sanitizedDescription = this.removeHtmlTags(item.SKILL_DESCRIPTION);
    return (
      <div className="col-md-4 ss-block pdl-0">
        <div className="tpb-outer">
          <div className="ss-box">
            {/* <div
            onClick={() => this.viewItem(item)}
            className="deleteIcon"
            data-toggle="modal"
            data-target="#myDeleteModal"
          >
            <img src={deleteIcon} alt="" />
          </div> */}
            <div className="rtb-menu draft-menu">
              {userRole === "2" ? (
                <div class="dropdown">
                  <a
                    class="rtb-menu-btn"
                    type="button"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={rtbmenu} />
                  </a>
                  <ul class="dropdown-menu dropdown-menu-left pull-right">
                    <li
                      onClick={() => this.viewItem(item)}
                      data-toggle="modal"
                      data-target="#myDeleteModal"
                    >
                      <button>
                        <span>
                          <img src={deleteIcon} />
                        </span>{" "}
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              ) : null}

              {/* <span className="hlp-email">{item.USER_EMAIL}</span> */}
              {item.USER_EMAIL ? (
                <span className="hlp-email">{item.USER_EMAIL}</span>
              ) : null}
            </div>

            <div
              className="ss-title-cont"
              onClick={() =>
                item?.SKILL_METADATA?.Template === "GenAi Automation"
                  ? this.props.history.push(
                      `/dashboard/skills/createAutomationV2/${encodeURIComponent(item?.SKILL_NAME)}&${item?.SKILL_METADATA?.v2AgentId}&${item?.SKILL_METADATA?.v2SkillId}?draftId=${item?.id}&orgId${item?.organizationId}`
                    )
                  : this.props.history.push(
                      `/dashboard/skills/viewSkill/${item.id}`
                    )
              }
            >
              <div
                className="ss-ico ss-text"
                style={{ backgroundColor: this.props.color }}
              >
                <p>{item.SKILL_NAME && item.SKILL_NAME.substring(0, 2)}</p>
              </div>
              <div className="hp-content">
                <h5 title={item.SKILL_NAME}>
                  {item.SKILL_NAME && item.SKILL_NAME}
                  {/*{item.SKILL_NAME && item.SKILL_NAME.length > 35 ? (
                  <span>
                    <strong>...</strong>
                  </span>
                ) : null} */}
                </h5>

                <div className="overflow-text">
                  <div className="inner-text">
                    <div
                      className="inner-text-hidden"
                      dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    ></div>

                    {item.SKILL_DESCRIPTION &&
                    item.SKILL_DESCRIPTION.length > 100 ? (
                      <>
                        <a
                          class="tlt-icon tl-tooltip"
                          href="javascript:void(0)"
                          data-toggle="popover"
                          data-html="true"
                          data-trigger="hover"
                          // data-placement={
                          //   (this.props.index + 1) % 3 === 0 ? "left" : "right"
                          // }
                          data-placement="auto right"
                          data-content={sanitizedDescription}
                          title="Description"
                        >
                          <img src={info} alt="" />
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="ss-footer">
              <div className="use-now">
                {this.state.isLoadingPlay ? (
                  <button className="btn btn-default use-button">
                    <div class="sp sp-circle text-light"></div>
                  </button>
                ) : (
                  <>
                    {item?.SKILL_METADATA?.Template === "Skill Set" ? (
                      <button
                        className="btn btn-default use-button"
                        onClick={() => {
                          this.props.history.push(
                            `/dashboard/skill-store/skill/${item?.SKILL_ID}`
                          );
                        }}
                      >
                        View Now
                      </button>
                    ) : (
                      <button
                        className="btn btn-default use-button"
                        onClick={() => {
                          this.props.setSelectedItem(item);
                          this.getExecutionRequirements(item);
                        }}
                      >
                        Use Now
                      </button>
                    )}
                  </>
                )}

                {/* <div className="use-ico">
                <img src={poygonplay} alt="" />
              </div> */}
              </div>
              <div
                id="alertModal"
                class="modal fade crt-skill alert-modal"
                role="dialog"
                data-backdrop="static"
                data-keyboard="false"
              >
                <div class="modal-dialog">
                  <div class="modal-content crt-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal">
                        &times;
                      </button>
                      <h4 class="modal-title">Supervity Says:</h4>
                    </div>
                    <div class="modal-body">
                      <form class="form-contain" action="javascript:void(0)">
                        <div class="frm-block alert-text">
                          <p>
                            Click <strong>'OK'</strong> to execute the skill in
                            normal window (Will restore browser if needed). So
                            make sure to save the unsaved data if any.
                          </p>
                          <p>
                            Click <strong>'Cancel'</strong> to execute skill in
                            new incognito window.
                          </p>
                        </div>
                        <div class="frm-btns">
                          <button
                            class="btn-outline"
                            data-dismiss="modal"
                            onClick={() => {
                              this.play(
                                this.props?.skillReducer?.selectedItem,
                                false
                              );
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn-primary"
                            data-dismiss="modal"
                            onClick={() => {
                              this.play(
                                this.props?.skillReducer?.selectedItem,
                                true
                              );
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="brand-list">
                {item?.SKILL_METADATA?.Template === "In-App Walkthrough"
                  ? "In-App Walkthrough"
                  : item?.SKILL_METADATA?.Template === "UserDocumentation"
                  ? "User Documentation"
                  : item?.SKILL_METADATA?.Template ===
                    "Import Data from Spreadsheet to Web App"
                  ? "Import Data from Spreadsheet to Web App"
                  : item?.SKILL_METADATA?.Template === "WebAutomation"
                  ? "Web Automation"
                  : item?.SKILL_METADATA?.Template === "UserOnboarding"
                  ? "User Onboarding"
                  : item?.SKILL_METADATA?.Template === "GenAi Automation"
                  ? "Workflow AI Agent"
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  skillReducer: state.skillReducer,
  snackReducer: state.snackReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    notify,
    changeSkillAreaView,
    viewHelperSkill,
    executeFlow,
    setSelectedItem,
  })
)(MyHelperItem);
